import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'src/ep-utils';
import { StateHelperService } from '../../../services/proprietary/state-helper.service';
import { DeleteArticlesLinkedToProfile, LinkProfileToArticle } from './contract-object.actions';
import { ContractObjectDefaults } from './contract-object.defaults';
import { AddProfilePointer, RemoveProfilePointer } from './contract.actions';
//import { AddNamePointer, RemoveNamePointer } from './contract.actions';
import { AddProfile, CloneProfile, DeleteProfile, RestoreProfile, UpdateProfile } from './profile.actions';

export interface ProfileStateModel {
    profile: any;
    currentID: string;
}

@State<ProfileStateModel>({
    name: 'profileState',
    defaults: {
        profile: {},
        currentID: null
    }
})
@Injectable()
export class ProfileState {
    constructor(private helper: StateHelperService) { }

    //******* SELECTORS *********

    @Selector()
    static fullState(state: ProfileStateModel) {
        return state.profile;
    }

    @Selector()
    static currentProfile(state: ProfileStateModel) {
        if (state.profile[state.currentID]) {
            return state.profile[state.currentID];
        } else {
            return {};
        }
    }

    @Selector()
    static profiles(state: ProfileStateModel) {
        let result: any = [];
        for (var i in state.profile) {
            result.push(state.profile[i]);
        }
        return result;
    }

    @Selector()
    static profileCount(state: ProfileStateModel) {
        let count = 0;
        for (var i in state.profile) {
            count++;
        }
        return count;
    }

    @Selector()
    static profileByID(state: ProfileStateModel) {
        return (profileID: string) => {
            let result: any = {};
            if (profileID) {
                for (var i in state.profile) {
                    if (state.profile[i].Profile_ID == profileID) {
                        result = state.profile[i];
                        break;
                    }
                }
            }

            return result;
        };
    }

    //******  ACTIONS  ******

    @Action(UpdateProfile)
    updateProfile(sc: StateContext<ProfileStateModel>, action: UpdateProfile) {
        const state = sc.getState();
        let profileID = action.profile.Profile_ID;
        let updateProfile: any = { ...action.profile };
        this.helper.setItemChanged(updateProfile, state.profile[profileID].Edit_Status);
        sc.patchState({
            profile: {
                ...state.profile,
                [profileID]: {
                    ...state.profile[profileID],
                    ...updateProfile
                }
            }
        });
    }

    @Action(DeleteProfile)
    deleteProfile(sc: StateContext<ProfileStateModel>, action: DeleteProfile) {
        const state = sc.getState();
        let profile = { ...state.profile }; //shallow copy Profile from state
        this.helper.setItemDeleted(profile, action.profileID);
        sc.patchState({ profile: profile });
        if (action.profileID < 0) {
            sc.dispatch(new RemoveProfilePointer(action.profileID.toString()));
        }
        sc.dispatch(new DeleteArticlesLinkedToProfile(action.profileID));
    }

    @Action(RestoreProfile)
    restoreProfile(sc: StateContext<ProfileStateModel>, action: RestoreProfile) {
        const state = sc.getState();
        let profile = { ...state.profile }; //shallow copy Profile from state
        this.helper.setItemRestored(profile, action.profileID);
        sc.patchState({ profile: profile });
    }

    @Action(CloneProfile)
    cloneProfile(sc: StateContext<ProfileStateModel>, action: CloneProfile) {
        const state = sc.getState();
        let srcID = action.profileID;
        let newID = this.helper.getTempID();
        let newProfile = cloneDeep(state.profile[srcID]);
        this.helper.setItemAdded(newProfile);
        newProfile.Profile_ID = newID;

        sc.patchState({
            currentID: newID,
            profile: { ...state.profile, [newID]: newProfile }
        });
        sc.dispatch(new AddProfilePointer(newID));
    }

    @Action(AddProfile)
    addProfile(sc: StateContext<ProfileStateModel>, action: AddProfile) {
        const state = sc.getState();
        let newID = this.helper.getTempID();
        let newProfile = this.helper.createDefaultItem(ContractObjectDefaults, 'Contract_Profile', action.profile);
        this.helper.setItemAdded(newProfile);
        newProfile.Profile_ID = newID;
        sc.patchState({
            currentID: newID,
            profile: { ...state.profile, [newID]: newProfile }
        });
        sc.dispatch(new AddProfilePointer(newID));

        let linkedArticleID = action.articleID;
        if (linkedArticleID && linkedArticleID != 0) {
            //New Action to update article with Profile_ID
            sc.dispatch(new LinkProfileToArticle(newProfile.Profile_ID, linkedArticleID));
        }
    }
}
